module.exports = __webpack_public_path__ + "img/users-medical.0015460e.svg";